import type { FC } from "react";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { useEnrichedWallet } from "../../contexts/enrichedWallet";
import { PublicKeyWalletName } from "../../utils/wallet/adapters/publicKey";
import { isPublicKeyWalletAdapter } from "../../utils/wallet/providers";

let hasConnected = false;

export const QueryParamUtils: FC = () => {
  const { connected, wallet, select } = useEnrichedWallet();
  const [searchParams, setSearchParams] = useSearchParams();

  // Clear query param and lastWatchedPubkey when switching from watched to connected wallet.
  // Only trigger after first connection to prevent params being cleared when using watched wallet link
  useEffect(() => {
    if (connected) {
      hasConnected = true;
    }
    if (
      hasConnected &&
      !connected &&
      !isPublicKeyWalletAdapter(wallet) &&
      wallet?.adapter.name &&
      searchParams.has("watching")
    ) {
      searchParams.delete("watching");
      setSearchParams(searchParams);
    }
  }, [connected, searchParams, setSearchParams, wallet, wallet?.adapter.name]);

  // Detect query param and select PublicKey wallet from WalletProvider.
  useEffect(() => {
    const address = searchParams.get("watching");
    if (!address) {
      return;
    }
    if (select) {
      select(PublicKeyWalletName);
    }
  }, [searchParams, select]);

  return null;
};
